import styled from "styled-components";

export const Wrapper = styled.div`
  margin: auto;
  width: 700px;
  .steps-container {
    padding: 0px 30px;
    margin-bottom: 20px;
    .ant-steps-item-process
      > .ant-steps-item-container
      > .ant-steps-item-content
      > .ant-steps-item-title {
      color: #fff;
      font-size: 11px;
      line-height: 15px;
    }
    .ant-steps-item-wait
      > .ant-steps-item-container
      > .ant-steps-item-content
      > .ant-steps-item-title {
      color: #fff !important;
      font-size: 11px;
      line-height: 15px;
    }
    .ant-steps-item-title {
      color: #fff !important;
      line-height: 15px;
      font-size: 11px;
    }
    .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
      color: black;
    }
  }
  .ant-form-item {
    margin-bottom: 0px;
  }
  .ant-form-item-explain-connected {
    width: auto;
    margin-top: 8px;
  }
  
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background: #FFE400;
    border: none;
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background: #FFD93D;
  }
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #0a4069;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: #a6b539;
    border-color: #a6b539;
  }
  .anticon svg {
    vertical-align: baseline;
    color: #FFFFFF;
  }

  @media (max-width: 900px) {
    width: 100%;
  }
  @media (max-width: 580px) {
    .steps-container {
      padding: 0px;
      margin-bottom: -10px;
      height: 200px;
      .ant-steps-vertical {
        height: 100%;
        .ant-steps-item {
          flex: 1;
        }
      }
      .ant-steps-item-container {
        height: 100%;
      }
      .ant-steps-item-process
        > .ant-steps-item-container
        > .ant-steps-item-content
        > .ant-steps-item-title {
        margin-top: 9px;
        font-size: 16px;
      }
      .ant-steps-item-wait
        > .ant-steps-item-container
        > .ant-steps-item-content
        > .ant-steps-item-title {
        margin-top: 9px;
        font-size: 16px;
      }
    }
  }
`;